module.exports = __webpack_public_path__ + "static/media/Scene 5.94af1a47.jpg";